module.exports = __webpack_public_path__ + "static/media/shuffle.5b851589.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle.svg
// module id = 1087
// module chunks = 1